import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-partd-cob-ohi-dw",
  templateUrl: "./partd-cob-ohi-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartDCobOhiDWComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.PartDCobOhiDW;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
